<ticketing-navbar></ticketing-navbar>
<div class="main home">
  <form>
    <div class="gestionWrap">
        <div class="layout">
            <ticketing-sidebar *ngIf="currentTurno" class="col-servicios"></ticketing-sidebar>        
            <router-outlet></router-outlet>
        </div>
        <div class="keyboardWrap conBG" *ngIf="toggleKeyboard">
            <ticketing-keyboard></ticketing-keyboard>
            <ticketing-numpad></ticketing-numpad>
        </div>
    </div>
  </form>
</div>
<!-- <div class="main home login" *ngIf="!currentTurno">
    <form>
        <div class="gestionWrap">
          <div class="layout">
              <ticketing-login class="col-login"></ticketing-login>
          </div>
          <div class="keyboardWrap conBG">
            <ticketing-keyboard></ticketing-keyboard>
            <ticketing-numpad></ticketing-numpad>
          </div>
        </div>
    </form>
</div>

<div class="main home" *ngIf="currentTurno">
  <form>
    <div class="gestionWrap">
        <div class="layout">
            <ticketing-sidebar class="col-servicios"></ticketing-sidebar>        
            <router-outlet></router-outlet>
        </div>
        <div class="keyboardWrap conBG" *ngIf="toggleKeyboard">
            <ticketing-keyboard></ticketing-keyboard>
            <ticketing-numpad></ticketing-numpad>
        </div>
    </div>
  </form>
</div>-->